import { render, staticRenderFns } from "./ChatClaudia.vue?vue&type=template&id=4e6a1eef&"
import script from "./ChatClaudia.vue?vue&type=script&lang=js&"
export * from "./ChatClaudia.vue?vue&type=script&lang=js&"
import style0 from "./ChatClaudia.vue?vue&type=style&index=0&id=4e6a1eef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports